siteNavigationApp.factory('MyProfileResource', ['$resource', ($resource) ->
  $resource "",{},
    get:
      method: 'GET'
      isArray: false
      url: APIRoutes.v3_my_profile_path()
])
